import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DOC_TYPES } from "@/content/apiCatalogue";

const slug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// One API listing: number, name, therapeutic area, document availability and a quote link that pre-fills the sourcing form.
export const ApiRow = ({ item, index }) => {
  const id = slug(item.name);
  const inDev = /development|validation/i.test(item.note || "");
  return (
    <li className="grid gap-3 py-5 transition-colors duration-300 hover:bg-accent-soft/60 lg:grid-cols-[56px_1.3fr_1fr_240px_150px] lg:items-center lg:gap-4 lg:py-4" data-testid={`api-row-${id}`}>
      <span className="hidden font-mono text-[12px] text-muted lg:block">{String(index + 1).padStart(3, "0")}</span>
      <div>
        <p className="font-display text-lg font-semibold tracking-[-0.02em] text-ink">{item.name}</p>
        {item.note && (
          <p className={`mt-1 font-mono text-[12px] uppercase tracking-[0.08em] ${inDev ? "text-amber-700 dark:text-amber-400" : "text-muted"}`}>
            {inDev ? `In development: ${item.note}` : item.note}
          </p>
        )}
      </div>
      <p className="text-[14px] text-muted">{item.category || "Therapeutic area on request"}</p>
      <ul className="flex flex-wrap gap-1.5" aria-label="Regulatory documents">
        {item.docs.length ? (
          DOC_TYPES.filter((d) => item.docs.includes(d)).map((d) => (
            <li key={d} className="border border-accent/50 bg-accent-soft px-2 py-0.5 font-mono text-[12px] text-accent">{d}</li>
          ))
        ) : (
          <li className="font-mono text-[12px] text-muted">Docs on request</li>
        )}
      </ul>
      <Link
        to={`/sourcing?product=${encodeURIComponent(item.name)}#enquiry`}
        className="inline-flex items-center gap-1 justify-self-start text-[14px] font-semibold text-accent underline-offset-4 hover:underline lg:justify-self-end"
        data-testid={`api-quote-${id}`}
      >
        Request quote <ArrowUpRight className="h-4 w-4" />
      </Link>
    </li>
  );
};
